import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75611ca4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "segmented-buttons inline-flex relative bg-gray-100 p-1 gap-1 rounded-md" }
const _hoisted_2 = ["disabled", "onClick"]

import { computed } from "vue";

type OptionValue = string | number;


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null,
    options: null,
    disabled: null
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props as {
  modelValue: OptionValue;
  options: Record<string, string> | Array<string>;
  disabled?: boolean;
}





const normalizedOptions = computed(() => {
  if (Array.isArray(props.options)) {
    return props.options.map((option) => ({
      value: option,
      label: option,
    }));
  }

  return Object.entries(props.options).map(([value, label]) => ({
    value,
    label,
  }));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(normalizedOptions), (option) => {
      return (_openBlock(), _createElementBlock("button", {
        type: "button",
        class: _normalizeClass(["flex-1 h-8 px-4 text-sm font-normal rounded-md transition-all duration-200 disabled:cursor-not-allowed disabled:opacity-60", 
        __props.modelValue === option.value
          ? 'bg-white text-primary shadow-sm'
          : 'text-gray-600 hover:text-primary'
      ]),
        key: option.value,
        disabled: __props.disabled,
        onClick: _withModifiers(($event: any) => (_ctx.$emit('update:modelValue', option.value)), ["prevent"])
      }, _toDisplayString(option.label), 11, _hoisted_2))
    }), 128))
  ]))
}
}

})